<template>
 <section class="faq">
  <h3 class="faq__header content__title">{{content.data.faq.header}}</h3>
    <ul class="faq__accordeon">
     <li v-for="(item, index) in faq" class="faq__item"  :key="index" v-on:click="faqTrigger(index)" v-bind:class="{'faq__ext-active': (currentFaq === index)}">
      <div class="faq__title">
        <h4 v-html="item.question"> </h4>
        <div class="faq__icon faq__icon--hide" v-show="currentFaq === index" > - </div>
        <div class="faq__icon faq__icon--show"  v-show="currentFaq !== index" > 
           <span>+</span>
            </div>
       
      </div>
      <transition mode="out-in" name="faq__fade" 
                  v-on:before-enter="beforeEnterFaq"
                  v-on:enter="enterFaq">
        <div class="faq__copy" v-show="currentFaq === index">
          <div class="faq__content" v-html="item.answer">
          </div>
        </div>
      </transition>
    </li>
  </ul>

 </section>
</template>

<script>

export default {
  name: "FAQ",
  inject: ['content'],
  data: function() {
    return {
      faq: this.content.data.faq.accordeon,
      currentFaq: 0,
    }
  },
  methods: {
        faqTrigger: function(newFaq) {
            if (newFaq === this.currentFaq) {
                this.currentFaq = -10
            } else {
                this.currentFaq = newFaq
            }
        },
        beforeEnterFaq: function(_t) {
          _t.style.display = 'block'
          _t.style.maxHeight = null
          _t.myHeight = _t.offsetHeight
          _t.style.maxHeight = 0
          _t.style.display = null
        },
        enterFaq: function(_t) {
          _t.style.maxHeight = _t.myHeight + 'px'
        }
    },

};
</script>


